//@flow
import React from 'react';
import {Link} from 'react-router-dom';
import {makeStyles, Button} from '@material-ui/core';

import SwitchableSection from '../../../../../elements/SwitchableSection';
import {HOME_PAGE_SECTION_NAMES} from '../../../utils/home-page-sections/constants';
import {colors} from '../../../../../assets/styles/colors';
import {Add, Visibility} from '@material-ui/icons';
import {useDeliveryShippingConfig} from '../../../../configure/logistics/logistics/utils';

const useStyles = makeStyles(theme => ({
  addBannerButton: {
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    color: colors.grey500,
    border: `2px dashed ${colors.grey500}`,
    borderRadius: '.75rem',
    paddingBlock: '.85rem',
  },
  bannerList: {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',

    '& > *': {
      borderBottom: `1px solid ${colors.grey300}`,
    },

    '& > *:last-child': {
      borderBottom: 'none',
    },
  },
  loader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
  },
  disabledRoot: {
    background: colors.grey300,
  },
  caption: {
    color: colors.grey500,
    fontSize: '1rem',
    fontWeight: 500,
    marginBottom: '1rem',
    display: 'block',
  },
  buttonContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '.25rem',
  },
}));

type Props = {
  sectionEnabled?: boolean,
};

export default function ShippingPromotion(props: Props) {
  const {sectionEnabled} = props;

  const classes = useStyles();
  const {logisticShippingDeliveryConfig} = useDeliveryShippingConfig();
  const emptyContent = !(
    logisticShippingDeliveryConfig &&
    logisticShippingDeliveryConfig.enabledPromotions
  );

  return (
    <SwitchableSection
      title="Promoción de envío"
      subtitle="Crea promociones para tus envíos"
      id={HOME_PAGE_SECTION_NAMES.SHIPPING_PROMOTION}
      classes={{
        root: (emptyContent || !sectionEnabled) && classes.disabledRoot,
      }}
    >
      <Button
        fullWidth
        className={classes.addBannerButton}
        component={Link}
        to="/configure/logistics/promotions"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className={classes.buttonContent}>
          {emptyContent ? <Add /> : <Visibility />}
          {emptyContent ? 'Agregar promoción' : 'Ver promoción'}
        </div>
      </Button>
    </SwitchableSection>
  );
}
